import React, { useContext,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
// import { iAeonShowAeonPay } from '../../library/iaeon_sdk.js';
// import { iAeonClose } from '../../library/iaeon_sdk.js';
// import { iAeonShowMemberPay } from '../../library/iaeon_sdk.js';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

import styles from '../../styles/Regi.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiSenyou(props) {


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	document.body.classList.remove('bg_white');
	// document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.add('is_behind');

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);


useEffect(() => {
	//お買物API：画面遷移API（支払画面
	props.okaimonoAPI_didScreenTransition("wait_payment");
}, []);


const goRegiSenyouComp = () => {
	props.setPage("regi_senyou_comp");
	// se08_se();
}
const goRegiSelfComp = () => {
	props.setPage("regi_self_comp");
	// se08_se();
}
const goRegiYujin = () => {
	props.setPage("regi_yujin");
	// se08_se();
}
const goGateQRErr = () => {
	// props.setPage("error_gateqr")
}

//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
// const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);

//会員コード連携バージョン確認：false 5.4.0より小さい 連携なし（暫定版 STEP1）、true 5.4.0以上 連携可能（連携版 STEP2）
// const { memberCodeVerCheck, updateMemberCodeVerCheck } = useContext(SharedInfoContext);


//精算確認API
const onSettleCheck = () => {
	console.log(`【settlecheckAPI】 決済完了 再び精算APIコール（タイマー発動）`);
	clearTimeout(stimer);
	clearTimeout(itimer);
	settlecheckAPI(props.shoppingStData.data.transactionno);
}

//精算確認API呼び出し用
useEffect(() => {
	if (props.setOnSettleCheckSenyou) {
		props.setOnSettleCheckSenyou(() => onSettleCheck);
	}
}, []);

const { settlecheckAPI, data: settlecheckData, loading: settlecheckLoading, error: settlecheckError } = useUserAPI();

let stimer = null;
let itimer = null;

useEffect(() => {
	// if(itimer == null && sharedInfo.intervalFlg == true){
	if(itimer === null){
		console.log("runInterval: "+props.shoppingStData.data.runInterval);
		console.log("props.timeoutCountFlg:"+props.timeoutCountFlg);
		var sinterval = props.shoppingStData.data.runInterval * 1000;
		if(props.timeoutCountFlg === true){ //決済予約API・決済APIがタイムアウト・通信エラーのためタイマー省略
			itimer = "aaa";
			settlecheckAPI(props.shoppingStData.data.transactionno);
		}else{ //通常動作
			stimer = setTimeout(function(){
				console.log("transactionno："+props.shoppingStData.data.transactionno);
				// itimer = setInterval(function(){
				// 	settlecheckAPI(props.shoppingStData.data.transactionno);
				// }, sinterval);
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);
			// },props.shoppingStData.runInterval);
			// },60000);
			},10000);
		}
	// }else{
	// 	clearTimeout(stimer);
	// 	clearTimeout(itimer);
	}

	return () => {
		clearTimeout(stimer);
		clearTimeout(itimer);
	};
}, []);


useEffect(() => {

	if(settlecheckData){
		clearTimeout(stimer);
		clearTimeout(itimer);
		if (settlecheckData.data) { //SUCCESS
			console.log(`【settlecheckAPI】 status: ${settlecheckData.data.status}`);
			console.log(`【settlecheckAPI】 qrcode: ${settlecheckData.data.qrcode}`);
			console.log(`sharedInfo.exitGateQR: ${sharedInfo.exitGateQR}`);
			console.log(`【settlecheckAPI】 settlementTime: ${settlecheckData.data.settlementTime}`);

			if(settlecheckData.data.status === 0){ //決済未完了 ERROR → エラー画面後に、商品登録画面へ
				console.log(`【settlecheckAPI】 決済未完了 ERROR`);
				props.setErrFlg(true);
				props.setErr([true, process.env.REACT_APP_ERROR_CODE_666, process.env.REACT_APP_ERROR_MESSAGE_666]);
				// props.setErr([true,`666`,`i1b0;お支払いが確認できませんでした;レジにてお支払いをお願いします。;;`]);

			}else if(settlecheckData.data.status === 1){ //決済完了 再び精算APIコール（タイマー発動）
				console.log(`【settlecheckAPI】 決済完了 再び精算APIコール（タイマー発動）`);
				var sinterval = props.shoppingStData.data.runInterval * 1000;
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);

			}else if(settlecheckData.data.status === 2){ //精算完了 支払い完了画面へ
				console.log(`【settlecheckAPI】 支払い完了画面へ`);
				console.log("【sharedInfo】 gateFlag:"+sharedInfo.gateFlag);

				//お買物API：清算完了API
				okaimonoAPI_didCompletedPayment();

				setTimeout(function(){
					if(sharedInfo.gateFlag === "1"){ //ゲート対象ON
						if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
							goRegiYujin();
						}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
							// goGateQRErr();
							goRegiSenyouComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}else{ //正常
							// updateExitGateQR(settlecheckData.data.qrcode);
							goRegiSenyouComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}
					}else{ //ゲート非対称OFF
						if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
							goRegiYujin();
						}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
							// goGateQRErr();
							goRegiSelfComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}else{ //正常
							goRegiSelfComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}
					}
				}, 400);

			}else if(settlecheckData.data.status === 3){ //精算未完了 支払い完了画面へ
				console.log(`【settlecheckAPI】 支払い完了画面へ`);
				console.log("【sharedInfo】 gateFlag:"+sharedInfo.gateFlag);

				//お買物API：清算完了API
				okaimonoAPI_didCompletedPayment();

				setTimeout(function(){
					if(sharedInfo.gateFlag === "1"){ //ゲート対象ON
						if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
							goRegiSelfComp();
						}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
							// goGateQRErr();
							goRegiSenyouComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}else{ //正常
							// updateExitGateQR(settlecheckData.data.qrcode);
							goRegiSenyouComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}
					}else{ //ゲート非対称OFF
						if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
							goRegiYujin();
						}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
							// goGateQRErr();
							goRegiSelfComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}else{ //正常
							goRegiSelfComp();

							// settlementTime: YYYY/MM/DD HH:mm:ss → yyyy-mm-dd hh:mm:ss
							let recorded_time = settlecheckData.data.settlementTime;
							recorded_time = recorded_time ? recorded_time.replace(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6') : recorded_time;
							let register_no = sharedInfo.registerNumber;
							let shop_code = String(sharedInfo.storeCode ?? '').padStart(10, '0');

							//お買物API：取引情報通知API
							props.okaimonoAPI_notifyTransactionData(recorded_time, register_no, shop_code);
						}
					}
				}, 400);
			}

		}else{ //ERROR
			console.log(`【settlecheckAPI】 errorCode: ${settlecheckData.errorCode}`);
			console.log(`【settlecheckAPI】 errorMessage: ${settlecheckData.errorMessage}`);
			console.log(`【settlecheckAPI】 isSuccess: ${settlecheckData.isSuccess}`);


			if(settlecheckData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${settlecheckData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(settlecheckData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${settlecheckData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else if(settlecheckData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${settlecheckData.errorCode}`,`${settlecheckData.errorMessage}`]);
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${settlecheckData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${settlecheckData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`,`${settlecheckData.errorMessage}`]);
			}
		}
	}
	if(settlecheckError){
		console.log("settlecheckError");
		console.log(settlecheckError);
		// if(settlecheckError.errorCode === "35"){
			// props.setErrFlg(true);
			// props.setErr([true,`35`,`;通信エラー35;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
			if(props.timeoutCount >= 2){
				console.log("props.timeoutCount:");
				console.log(props.timeoutCount);
				props.setPage("error_35");
			}else{
				let tc = props.timeoutCount + 1;
				props.setTimeoutCount(tc);
				console.log("props.timeoutCount:");
				console.log(tc);

				var sinterval = props.shoppingStData.data.runInterval * 1000;
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);
			}
		// }else{
		// 	props.setErrFlg(true);
		// 	props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// }
	}
	if(settlecheckLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}

	return () => {
		clearTimeout(stimer);
		clearTimeout(itimer);
	};
}, [settlecheckData,settlecheckLoading,settlecheckError]);

const sharedInfo = useContext(SharedInfoContext);
const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { aeonPayFlg, updateAeonPayFlg } = useContext(SharedInfoContext);


//----------------------------------------
//お買物API：清算完了API
//----------------------------------------

const okaimonoAPI_didCompletedPayment = async () => {
	try {
		console.log("----------------------------");
		console.log("【didCompletedPayment】お買物API：清算完了API call");

		const { callbackId, result } = await callOkaimonoAPI('didCompletedPayment');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didCompletedPayment】success", result);
			console.log("【didCompletedPayment】result:", result.result);

		}else {
			console.log("【didCompletedPayment】error", result);
			console.log("【didCompletedPayment】result:", result.result);
		}

	} catch (error) {
		console.log('【didCompletedPayment】error', error);
	}
};


//----------------------------------------
//お買物API：クーポン・バーコード画面表示API
//----------------------------------------

const okaimonoAPI_tapCouponBarcode = async () => {
	try {
		props.setSoundState("se08_se");

		//お買物API：クーポン・バーコード画面表示API
		console.log("----------------------------");
		console.log("【tapCouponBarcode】お買物API：クーポン・バーコード画面表示API call");

		const { callbackId, result } = await callOkaimonoAPI('tapCouponBarcode');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【tapCouponBarcode】success", result);
			console.log("【tapCouponBarcode】result:", result.result);

		}else {
			console.log("【tapCouponBarcode】error", result);
			console.log("【tapCouponBarcode】result:", result.result);
		}

	} catch (error) {
		console.log('【tapCouponBarcode】error', error);
	}
};


return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>
	<div className={styles.regiBox}>
		<div className={styles.regiBoxSpace02}></div>
		<div className={styles.regiBox_regiSenyou}>
			{/* {
				(() => {
					if (props.otbErr !== true){
						if (props.shoppingData.data) { // SUCCESS
							return (
								<div className={styles.regiBox_codeRenkei_label}>
									<div className={`${styles.codeRenkei_circle} ${styles.is_active}`}>
										<span className={styles.codeRenkei_circle01}></span>
									</div>
									<span className={styles.regiBox_codeRenkei_label_txt}>iAEON会員コード認証済</span>
								</div>
							)
						}
					}
				})()
			} */}
			<p className={styles.regiBox_regiSenyou_tit}>レジ番号</p>
			<p className={styles.regiBox_regiSenyou_num}>{sharedInfo.signNumber}</p>
			<p className={styles.regiBox_regiSenyou_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>
				{
					(() => {
						if (props.shoppingData) {
							if (props.shoppingData.data) { // SUCCESS
								return props.shoppingData.data.sumItemCount;
							} else { // ERROR
								return 0;
							}
						} else {
							return 0;
						}
					})()
				}
				</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div>

		{/* <div className={styles.regiBox_regiSelf} onClick={goRegiSelfComp}>
			<div className={styles.regiBox_regiSelf_img}>
				<img src="/images/img_regi_self.svg" alt="" width="161" height="159"/>
			</div>
			<p className={styles.regiBox_regiSelf_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>12</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div> */}
	</div>


	<div className={styles.barcodeBox}>
		<p className={styles.barcodeBox_txt}>お支払いを完了する前に<br/>下のボタンをタップしてください
		<small>※AEON Payをご利用の方もこちらから</small></p>
		<div className={styles.barcodeBox_btn} onClick={okaimonoAPI_tapCouponBarcode}>
			<img src="/images/btn_barcode.png" alt="" width="206" height="56" />
		</div>
	</div>


	<div className={`${styles.payCompBox} ${styles.is_last}`}>
		<p className={styles.payCompBox_txt}>お支払いが済みましたら<br/>下のボタンをタップしてください</p>
		<div className={`commonBtn commonBtn01 ${styles.payCompBox_btn}`} onClick={() => {onSettleCheck();props.setSoundState("se08_se");}}><span>お支払い完了</span></div>
	</div>

	</div>

	</>
)

}
